import React, { Suspense, lazy } from 'react';
import './App.css';
import Homepage from './components/homepage/homepage';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useUser } from './user-provider';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';

// The authenticated views pull in the bulk of the application (the stack, the
// maker sidebar, the tag system). Loading them on demand keeps them out of the
// bundle a signed-out visitor has to download to reach the login form.
const Box = lazy(() => import('./components/box'));
const Touch = lazy(() => import('./components/touch'));

toast.configure();

// Defined at module scope. Declaring these inside App() gave them a new
// component identity on every render, which remounted the whole routed subtree
// (including the WebGL model viewer) whenever `user` or `isAuthenticating`
// changed.
function RequireUser({ comp: Component, user, redirect }) {
  return !user ? <Navigate to={redirect} /> : <Component user={user} />;
}

function RequireAnonymous({ comp: Component, user, redirect }) {
  return user ? <Navigate to={redirect} /> : <Component />;
}

// The first frame, painted before auth resolves and again while a lazy route
// chunk is on its way. App used to return null in both cases, which left
// #root empty for the whole Cognito round trip: no first paint until the
// session was known, and nothing on screen if that round trip was slow.
function AppShell() {
  return (
    <div className="app-shell" aria-busy="true" aria-live="polite">
      <span className="app-shell-spinner" />
      <span className="visually-hidden">Loading</span>
    </div>
  );
}

function App() {
  const { isAuthenticating, user } = useUser();

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          {isAuthenticating ? (
            <AppShell />
          ) : (
            <Suspense fallback={<AppShell />}>
              <Routes>
                <Route
                  path="/touch"
                  element={
                    <RequireUser comp={Touch} user={user} redirect="/" />
                  }
                />
                <Route
                  path="/box"
                  element={<RequireUser comp={Box} user={user} redirect="/" />}
                />
                <Route
                  path="/"
                  element={
                    <RequireAnonymous
                      comp={Homepage}
                      user={user}
                      redirect="/box"
                    />
                  }
                />
                {/*<Route component={() => <p>404 page not found</p>} />*/}
              </Routes>
            </Suspense>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
